import React from "react";
import PropTypes from "prop-types";
import {
  Grid,
  Typography,
  FormControlLabel,
  RadioGroup,
  FormControl,
} from "@material-ui/core";
import { translate as t } from "../../../../translate/localization";
import useStyles, { CustomRadio } from "../../styles";

export default function RowEnergeticEfficiency({
  energeticEfficiency,
  setEnergeticEfficiency,
}) {
  const { secondColumn } = useStyles();
  return (
    <>
      <Grid item xs={6} container alignItems="center">
        <Typography variant="body2">
          {t("request-section.vehicles-energetic-efficiency")}:
        </Typography>
      </Grid>
      <Grid item xs={6} className={secondColumn}>
        <FormControl component="fieldset">
          <RadioGroup
            name="energetic-efficiency"
            value={energeticEfficiency}
            onChange={(e) => setEnergeticEfficiency(Number(e.target.value))}
          >
            <Grid item container xs={12} alignItems="center">
              <FormControlLabel
                value={0}
                control={<CustomRadio disableRipple />}
                label={<Typography variant="body2">0%</Typography>}
              />
              <FormControlLabel
                value={15}
                control={<CustomRadio disableRipple />}
                label={<Typography variant="body2">15%</Typography>}
              />
              <FormControlLabel
                value={20}
                control={<CustomRadio disableRipple />}
                label={<Typography variant="body2">20%</Typography>}
              />
              <FormControlLabel
                value={30}
                control={<CustomRadio disableRipple />}
                label={<Typography variant="body2">30%</Typography>}
              />
            </Grid>
          </RadioGroup>
        </FormControl>
      </Grid>
    </>
  );
}

RowEnergeticEfficiency.propTypes = {
  energeticEfficiency: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  setEnergeticEfficiency: PropTypes.func,
};

RowEnergeticEfficiency.defaultProps = {
  energeticEfficiency: "0",
  setEnergeticEfficiency: () => {},
};
